import * as React from "react";
import {
  AppItem,
  NavDrawer,
  NavDrawerBody,
  NavItem,
  Tooltip,
  useRestoreFocusTarget,
} from "@fluentui/react-components";

import {
  ArrowSwap24Filled,
  ArrowSwap24Regular,
  ChartMultiple24Filled,
  ChartMultiple24Regular,
  DocumentText24Filled,
  DocumentText24Regular,
  PersonSupport24Filled,
  PersonSupport24Regular,
  PersonCircle32Regular,
  Settings24Filled,
  Settings24Regular,
  bundleIcon,
} from "@fluentui/react-icons";
import { ReactComponent as ConnectLogoIcon } from "../../assets/connect-logo.svg";

const KpiIcon = bundleIcon(ChartMultiple24Filled, ChartMultiple24Regular);
const TransactionsIcon = bundleIcon(ArrowSwap24Filled, ArrowSwap24Regular);
const MerchantsIcon = bundleIcon(PersonSupport24Filled, PersonSupport24Regular);
const ApprenticeWizardsIcon = bundleIcon(
  DocumentText24Filled,
  DocumentText24Regular,
);
const SettingsIcon = bundleIcon(Settings24Filled, Settings24Regular);

export const AdminMenu = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const restoreFocusTargetAttributes = useRestoreFocusTarget();

  return (
    <div onClick={(e) => e.stopPropagation()}>
      {/* Gear button */}
      <Tooltip content="Admin beállítások" relationship="label">
        <button
          onClick={() => setIsOpen(true)}
          {...restoreFocusTargetAttributes}
          aria-expanded={isOpen}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: 6,
            marginTop: 18,
          }}
        >
          <SettingsIcon />
        </button>
      </Tooltip>

      {/* Backdrop */}
      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            zIndex: 1000,
          }}
        />
      )}

      {/* Drawer */}
      <NavDrawer
        open={isOpen}
        type="overlay"
        position="end"
        onOpenChange={(_, data) => setIsOpen(data.open)}
        style={{ zIndex: 1001 }}
      >
        <NavDrawerBody>
          <AppItem icon={<PersonCircle32Regular />}>Admin felület</AppItem>
          <NavItem href="/admin/connect" value="0" icon={<ConnectLogoIcon />}>
            Connect
          </NavItem>
          <NavItem href="/admin/kpi" icon={<KpiIcon />} value="1">
            KPI
          </NavItem>{" "}
          <NavItem
            href="/admin/transactions"
            icon={<TransactionsIcon />}
            value="2"
          >
            Tranzakciók
          </NavItem>
          <NavItem href="/admin/merchants" icon={<MerchantsIcon />} value="3">
            Kereskedők
          </NavItem>
          <NavItem
            href="/admin/apprenticeWizards"
            icon={<ApprenticeWizardsIcon />}
            value="4"
          >
            Bevallás
          </NavItem>
          <NavItem
            href="/admin/m2m"
            //icon={<ApprenticeWizardsIcon />}
            value="5"
          >
            <span style={{ marginLeft: 40 }}>M2M</span>
          </NavItem>
        </NavDrawerBody>
      </NavDrawer>
    </div>
  );
};
